<template>
    <div class="center">
        <div class="loader" :class="size"></div>
    </div>
</template>
<script>
  export default {
    name: 'Loading',
    props: {
      size: {
        default: 'small',
        validator(value) {
          return ['small', 'medium', 'big'].indexOf(value) !== -1;
        },
      },
    },
  };
</script>
<style scoped lang="scss">
.center {
    display: flex;
    justify-content: center;
}
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin: 60px auto;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(0, 0, 0, 0.2);
  border-right: 1.1em solid rgba(0, 0, 0, 0.2);
  border-bottom: 1.1em solid rgba(0, 0, 0, 0.2);
  border-left: 1.1em solid #464646;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
  &.small {
    font-size: 6px;
  }
  &.medium {
    font-size: 8px;
  }
  &.big {
    font-size: 12px;
  }
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
